import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addVahanData } from "../../Redux/actions/NumBikeation";
import { addcarnum } from "../../Redux/actions/NumCaration";
import insurance from "../../assets/insurance.svg";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { NavbarJourney } from "../Navbar/NavbarJourney";
import "./NuCar.css";
import bike from "../../assets/icons/bike.png";
import { Form, Input, Button, Select, Row, Col, Spin } from "antd/lib";

export default function PospNumCar() {
  const [formLayout] = useState("vertical");
  const history = useHistory();
  const [form] = Form.useForm();
  const { Option } = Select;
  const bikenum = useSelector((state) => state.vehicledetail.bikenum);

  const dispatch = useDispatch();
  const [open, setopen] = useState(false);
  const [BaseUrl, setBaseURL] = useState("");
  const [loading, setLoading] = useState(false);

  const isuser = JSON.parse(localStorage.getItem("vibeUser"));
  console.log(isuser);
  useEffect(() => {
    const BASEURL = process.env.REACT_APP_UAT_BASE_URL;
    setBaseURL(BASEURL);
  }, [BaseUrl]);
  console.log("bikenum", bikenum);
  const prefixSelector = (
    // <Form.Item name="phonenumber" noStyle>
    <Select
      style={{
        width: 70,
      }}
      defaultValue="+91"
    >
      <Option value="+91">+91</Option>
    </Select>
  );
  const handleClear = () => {
    form.resetFields();
  };
  const onFinish = (values) => {
    console.log(values);
    setLoading(true);
    setopen(true);
    if (isuser !== null) {
      var is_POSP = isuser.isPOSP === true ? 1 : 0;
      var posp_id = isuser.isPOSP === true ? isuser.pospid : "";
    } else {
      is_POSP = 0;
      posp_id = "";
    }
    const url = `${BaseUrl}v2/car_insurances/register`;
    axios
      .post(url, {
        car_number: values.carNumber,
        phonenumber: values.phonenumber,
        isPOSP: is_POSP,
        posp_id: posp_id,
      })
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          let data = res.data.data;
          console.log(data);
          // localStorage.setItem("vibeReg", JSON.stringify(data));
          // setLoading(false);
          dispatch(addcarnum(data));
          const Url1 = `${BaseUrl}getVehicleDetails`;
          axios
            .post(Url1, {
              vehicleNumber: values.carNumber,
            })
            .then((res) => {
              console.log(res);
              let bikeresult = res.data.data;
              console.log(bikeresult);
              // console.log(bikeresult)
              dispatch(addVahanData(bikeresult));
              history.push("/offlineCarMake");
              // localStorage.setItem("bikeResult", JSON.stringify(bikeresult));
            })
            .catch((err) => {
              console.log(err);
              setLoading(false);
            });
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setopen(false);
      });
  };
  const onFinishFailed = (values) => {
    console.log(values);
  };
  const handleInputChange = (e) => {
    e.target.value = e.target.value.toUpperCase();
    form.setFieldsValue({ bikeNumber: e.target.value });
  };

  return (
    <>
      <Spin spinning={open}>
        <NavbarJourney />
        <section
          className="bg-light d-flex align-items-center justify-content-center"
          style={{ minHeight: "calc(100vh - 50px)" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-md-6 img-0 col-sm-0  p-2">
                <div className="m-4">
                  <img
                    className="img-fluid"
                    src={insurance}
                    width={500}
                    alt=""
                  />
                </div>
              </div>
              <div className="col-md-6 col-sm-12 p-2 d-flex flex-column justify-content-center align-items-center p-4 outer-insur">
                <h4 className="text-blue">
                  Save upto 85%* on Two Wheeler Insurance
                </h4>
                <p className="my-3">Stay home & renew in 2 minutes</p>
                <div className="d-flex align-items-center mt-4">
                  <img
                    alt=""
                    style={{ width: 20 }}
                    src="https://firebasestorage.googleapis.com/v0/b/goodfood-659aa.appspot.com/o/Icons%2FBike_Ins%2Fflash.png?alt=media&token=c7213ae8-4a09-4a72-9800-e6eb5e59ff75"
                  />
                  <small className="me-4 ms-2 text-success fw-bold">
                    Instant Policy
                  </small>
                  <img
                    alt=""
                    style={{ width: 20 }}
                    src="https://firebasestorage.googleapis.com/v0/b/goodfood-659aa.appspot.com/o/Icons%2FBike_Ins%2Fbank.png?alt=media&token=4cc16690-6e13-4219-a6ff-dd513fe04d1f"
                  />
                  <small className="me-4 ms-2 text-warning fw-bold">
                    Best Prices
                  </small>
                  <img
                    alt=""
                    style={{ width: 20 }}
                    src="https://firebasestorage.googleapis.com/v0/b/goodfood-659aa.appspot.com/o/Icons%2FBike_Ins%2Fdocuments.png?alt=media&token=7923cd01-4150-4801-a4bf-8a42120125c9"
                  />
                  <small className="me-4 ms-2 text-info fw-bold">
                    No Paperwork
                  </small>
                </div>
                <Form
                  layout={formLayout}
                  form={form}
                  style={{ width: "70%", paddingTop: "30px" }}
                  requiredMark={false}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                >
                  <Form.Item
                    name="carNumber"
                    rules={[
                      {
                        pattern: /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,2}[0-9]{3,4}$/i,
                        message: "Invalid Vehicle No",
                      },
                      { required: true, message: "Enter Vehicle No" },
                    ]}
                  >
                    <Input
                      onChange={handleInputChange}
                      placeholder="Enter Car Number (eg. DL1SAB1234)"
                    ></Input>
                  </Form.Item>
                  <Form.Item
                    name="phonenumber"
                    rules={[
                      {
                        pattern: /^([0|+[0-9]{1,5})?([6-9][0-9]{9})$/,
                        message: "Invalid Mobile No",
                      },
                      { required: true, message: "Enter Mobile No" },
                    ]}
                    initialValue={bikenum?.phonenumber}
                  >
                    <Input
                      maxLength={10}
                      addonBefore={prefixSelector}
                      placeholder="Enter Mobile Number (eg. 9876543210)"
                    ></Input>
                  </Form.Item>
                  <Row gutter={24} className="justify-content-center">
                    <Col span={12}>
                      <Form.Item>
                        <Button
                          style={{ width: "100%" }}
                          // loading={loading}
                          type="primary"
                          htmlType="submit"
                        >
                          View Price
                        </Button>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item>
                        <Button
                          className="clear-button-ant"
                          type="primary"
                          onClick={handleClear}
                        >
                          Clear
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
                <div className="h6 text-center" style={{ fontSize: "0.7rem" }}>
                  <img
                    className="mx-1"
                    style={{ maxHeight: "0.8rem" }}
                    src={bike}
                    alt=""
                  />{" "}
                  <a href="#">Don't have a Bike number?</a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Spin>
    </>
  );
}
